<template>
	<div class="flex flex-col gap-3"><slot/></div>
</template>
<script setup lang="ts"></script>